"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SubscriptionGa4Product {
    constructor(item_id, item_name, currency, index, item_brand, item_category, item_category2, item_variant, gear, engine, capacity, power, drive, subscription_type, list_type, price, quantity, list) {
        this.item_id = item_id;
        this.item_name = item_name;
        this.currency = currency;
        this.index = index;
        this.item_brand = item_brand;
        this.item_category = item_brand;
        this.item_category2 = item_category2;
        this.item_variant = item_category2;
        this.gear = gear;
        this.engine = engine;
        this.capacity = capacity;
        this.power = power;
        this.drive = drive;
        this.subscription_type = subscription_type;
        this.list_type = list_type;
        this.price = price;
        this.quantity = quantity;
        this.list = list;
    }
    setIndex(index) {
        this.index = index;
    }
    setListType(count) {
        this.list_type = count === 1 ? 'unique' : 'merged';
    }
}
exports.default = SubscriptionGa4Product;
